module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.impressionRevenueTableData.length > 0) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [(_vm.impressionRevenueReportData.length > 0) ? _c('JsonCSV', {
    staticClass: "btn btn-default atd-report-download",
    staticStyle: {
      "background-color": "#0da1f5",
      "border": "none",
      "-moz-box-shadow": "2px 2px 4px #000000",
      "-webkit-box-shadow": "2px 2px 4px #000000",
      "box-shadow": "2px 2px 4px #000000"
    },
    attrs: {
      "advancedOptions": _vm.tsting(),
      "data": _vm.csvData,
      "name": _vm.reportName
    }
  }, [_c('i', {
    staticClass: "iconsmind-Data-Download",
    staticStyle: {
      "color": "#fff",
      "font-weight": "bold"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "atd-title-text"
  }, [_vm._v("Download")])]) : _vm._e()], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "align-middle d-inline-block",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "min-width": "180px"
    },
    attrs: {
      "lang": _vm.lang,
      "shortcuts": _vm.shortcuts,
      "mode": "range",
      "range": "",
      "not-after": _vm.endDate
    },
    on: {
      "change": function($event) {
        return _vm.getRevenueImpressionReports()
      }
    },
    model: {
      value: (_vm.selectedValueRange),
      callback: function($$v) {
        _vm.selectedValueRange = $$v
      },
      expression: "selectedValueRange"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "table-container",
    class: (_vm.isLoading) ? 'table-container-loading' : 'table-container'
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_c('el-row', {
    staticClass: "text-center text-uppercase",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', [_vm._v("Date")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.tableBidderName), function(bidder, index) {
    return _c('th', {
      key: index
    }, [_c('el-row', {
      staticStyle: {
        "width": "240px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-col', {
      staticClass: "text-center text-uppercase",
      attrs: {
        "span": 24
      }
    }, [_c('span', [_vm._v(_vm._s(bidder))])]), _vm._v(" "), _c('el-col', {
      staticClass: "atd-revenue-report ",
      attrs: {
        "span": 24
      }
    }, [_c('el-col', {
      attrs: {
        "span": 9
      }
    }, [_c('span', [_vm._v("Impressions")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 9
      }
    }, [_c('span', [_vm._v("Revenue")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('span', [_vm._v("eCPM")])])], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('th', {
    staticStyle: {
      "position": "sticky",
      "top": "0"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "220px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "text-center text-uppercase",
    attrs: {
      "span": 24
    }
  }, [_c('span', [_vm._v("Total")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('span', [_vm._v("Impressions")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_vm._v("Revenue")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_vm._v("eCPM")])])], 1)], 1)], 1)], 1)], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.impressionRevenueTableData), function(revenue, parentIndex) {
    return _c('tr', {
      key: parentIndex
    }, [_c('td', [_c('span', {
      staticClass: "font-weight-medium"
    }, [_vm._v(_vm._s(_vm.dateFormater(revenue.date)))])]), _vm._v(" "), _vm._l((_vm.tableBidderName), function(bidder, childindex) {
      return _c('td', {
        key: childindex
      }, [_c('el-row', {
        staticStyle: {
          "width": "240px"
        }
      }, [_c('el-col', {
        attrs: {
          "span": 24
        }
      }, [_c('el-col', {
        attrs: {
          "span": 10
        }
      }, [(_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'impression')) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'impression'))))])]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 8
        }
      }, [(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue') != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue')) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue'))))])]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 4
        }
      }, [(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'revenue') != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'ecpm') == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.getBidderTotalRevenueAndImpression(parentIndex, bidder, 'ecpm')))])])], 1)], 1)], 1)
    }), _vm._v(" "), _c('td', [_c('el-row', {
      staticStyle: {
        "width": "220px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [(_vm.addCommas(revenue.impression) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(revenue.impression)))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [(revenue.revenue != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (_vm.addCommas(revenue.revenue) == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(_vm.addCommas(revenue.revenue)))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [(revenue.ecpm != 0) ? _c('span', [_vm._v("$")]) : _vm._e(), _vm._v(" "), (revenue.ecpm == 0) ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(revenue.ecpm))])])], 1)], 1)], 1)], 2)
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr'), _c('tr', [_c('th', [_c('el-row', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', [_vm._v("Total")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.tableBidderName), function(bidder, childindex) {
    return _c('td', {
      key: childindex
    }, [_c('el-row', {
      staticStyle: {
        "width": "240px"
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal(bidder, 'impression'))))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('span', [_vm._v("$")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal(bidder, 'revenue'))))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('span', [_vm._v("$")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getColumnCPM(bidder)))])])], 1)], 1)], 1)
  }), _vm._v(" "), _c('td', [_c('el-row', {
    staticStyle: {
      "width": "220px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal('total', 'impression'))))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('span', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.addCommas(_vm.getColumnTotal('total', 'revenue'))) + "\n                                                                    ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('span', [_c('span', [_vm._v("$")]), _vm._v(_vm._s(_vm.getColumnCPM('total')) + "\n                                                                    ")])])], 1)], 1)], 1)], 2)])])])])], 1)], 1) : _c('div', {
    staticClass: "text-center d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "loading"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h1', [_vm._v("Revenue")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "downloadcon"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-785346e7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/reports.vue
// module id = 711
// module chunks = 2